<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { initializeFCM } from './firebase/messaging';
import { getCurrentUser } from './firebase';
import GlobalLoader from './components/common/GlobalLoader.vue';
import { useGlobalLoader } from './composables/useGlobalLoader';
import Navbar from './components/common/Navbar.vue';

const { showLoader, hideLoader } = useGlobalLoader();
const route = useRoute();

onMounted(async () => {
	try {
		showLoader();
		initializeFCM();
		const router = useRouter();
		const user = await getCurrentUser();
		console.info('Current User:', user);
		if (!user) {
			return router.replace('/login');
		}
	} catch (error) {
		throw error;
	} finally {
		hideLoader();
	}
});

</script>

<template>
	<div class="w-screen h-screen flex flex-col items-stretch justify-stretch relative">
		<Navbar v-if="!route.meta.hideNavbar" />
		<RouterView />
		<GlobalLoader />
	</div>
</template>